/**
 *
 * @module redeemRetryHandler
 *
 */

import Check from 'check-types';
import Exception from './../services/exception/entry';
import PurchaseManager from './purchaseManager';
import Receipt from './receipt';

const InvalidArgumentException = Exception.InvalidArgumentException;

const {
    instanceStrict
} = Check.assert;

/**
 *
 * @class RedeemRetryHandler
 *
 */
export default class RedeemRetryHandler {

    /**
     *
     * @param {SDK.Purchase.PurchaseManager} provider
     * @param {SDK.Purchase.Receipt} receipt
     *
     */
    constructor(provider, receipt) {

        const errorMessage = {
            ctor: 'RedeemRetryHandler(provider, receipt)',
            get provider() {
                return `${this.ctor} needs SDK.Purchase.PurchaseManager instance`;
            },
            get receipt() {
                return `${this.ctor} needs SDK.Purchase.Receipt instancee`;
            }
        };

        instanceStrict(provider, PurchaseManager, errorMessage.provider, InvalidArgumentException); // eslint-disable-line
        instanceStrict(receipt, Receipt, errorMessage.receipt, InvalidArgumentException); // eslint-disable-line

        /**
         *
         * @access public
         * @type {SDK.Purchase.PurchaseManager}
         *
         */
        this.provider = provider;

        /**
         *
         * @access public
         * @type {SDK.Purchase.Receipt}
         *
         */
        this.receipt = receipt;

    }

    /**
     *
     * @access private
     * @desc handles the running of SDK.Purchase.PurchaseManager.redeemPurchases
     * @returns {Promise<AccessStatus>}
     *
     */
    run() {

        const { provider, receipt } = this;

        return provider.redeemPurchases(receipt.receiptCredentials, this);

    }

}



// WEBPACK FOOTER //
// ./src/purchase/redeemRetryHandler.js